module.exports = __webpack_public_path__ + "static/img/06.e0cac9c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/familybuilding/06.jpg
// module id = GmVg
// module chunks = 0